module.exports = __webpack_public_path__ + "img/地图D-菲利普岛自然公园.2e791dea.png";